module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter"
  }, [_c('p', {
    staticClass: "ch-tit"
  }, [_c('b', [_vm._v("Craft Apron")])]), _vm._v(" "), _c('p', {
    staticClass: "ch-au"
  }, [_vm._v("Virginia Lindsay")])]), _vm._v(" "), _c('div', {
    staticClass: "chap1"
  }, [_c('p', {
    staticClass: "noindentx"
  }, [_c('b', [_vm._v("FINISHED SIZE:")]), _vm._v(" 17˝ × 11˝")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentno"
  }, [_c('i', [_vm._v("When I have a booth at a craft show, I look forward to the time when I can walk around and shop the other tables. I started making these craft aprons to sell to other vendors and the many DIYers who are shopping. This design has seven pockets to keep you extra organized")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "imagef"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg5.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fcap"
  }, [_c('i', [_vm._v("Fabric: Painter’s drop cloth canvas, Kona Cotton in Tangerine from Robert Kaufman Fabrics, and Dolce by Tanya Whelan for FreeSpirit Fabric")])]), _vm._v(" "), _c('div', {
    staticClass: "grey"
  }, [_c('p', {
    staticClass: "noindents"
  }, [_c('span', {
    staticClass: "grey1"
  }, [_c('b', [_vm._v("VIRGINIA LINDSAY")])]), _vm._v(" is a self-taught sewist and lover of all things fabric. She is the author of a popular sewing blog and the designer behind Gingercake Patterns. Several of her patterns are published by Simplicity. Virginia lives in Freeport, Pennsylvania.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg5-1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_c('span', {
    staticClass: "grey1"
  }, [_c('b', [_vm._v("WEBSITE:")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "http://gingercake.org",
      "target": "_blank"
    }
  }, [_vm._v("gingercake.org")])]), _vm._v(" "), _c('p', {
    staticClass: "line1"
  }), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_vm._v("This project originally appeared in "), _c('i', [_vm._v("Sewing to Sell—The Beginner’s Guide to Starting a Craft Business")]), _vm._v(", by Virginia Lindsay, available from Stash Books.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg5-2.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "ma"
  }, [_c('b', [_vm._v("Materials")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentsa"
  }, [_c('i', [_vm._v("Quilting-weight fabric is recommended for the pockets and works with a layer of fusible interfacing for the apron body. A heavier-weight fabric would also work for the apron body and eliminate the need for interfacing")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "ma1"
  }, [_c('b', [_c('i', [_vm._v("Cotton fabric")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentsa"
  }, [_vm._v("APRON BODY: 2 pieces 12˝ × 18˝")]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_vm._v("LARGE POCKET: 1 piece 14˝ × 18˝")]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_vm._v("SMALL POCKET: 1 piece 10˝ × 18˝")]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_vm._v("TIES: 2 pieces 3˝ × 36˝")]), _vm._v(" "), _c('p', {
    staticClass: "ma1"
  }, [_c('b', [_c('i', [_vm._v("Other")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentsa"
  }, [_vm._v("FUSIBLE INTERFACING: 1 piece 12˝ × 18˝ for apron body (needed if using quilting-weight cotton)")]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_vm._v("AIR- OR WATER-SOLUBLE FABRIC-MARKING PEN")]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_vm._v("LIGHTWEIGHT DOUBLE-SIDED")]), _vm._v(" "), _c('p', {
    staticClass: "noindentsn"
  }, [_vm._v("FUSIBLE WEB ("), _c('i', [_vm._v("optional")]), _vm._v("): Small scrap")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg6.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_vm._v("Instructions")]), _vm._v(" "), _c('p', {
    staticClass: "noindentsa"
  }, [_c('i', [_vm._v("Seam allowances are ¼˝ unless otherwise noted")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_c('b', [_vm._v("PREPARE THE PIECES")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentsa"
  }, [_c('span', {
    staticClass: "ro"
  }, [_c('b', [_vm._v("1.")])]), _vm._v(" If you are using quilting-weight cotton for the main piece of the apron, follow the manufacturer’s instructions to fuse interfacing to the wrong side of the 12˝ × 18˝ front apron body.")]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_c('span', {
    staticClass: "ro"
  }, [_c('b', [_vm._v("2.")])]), _vm._v(" Fold the large pocket in half lengthwise, wrong sides together, to make a folded piece 7˝ × 18˝. Press the folded edge, pin if needed, and edgestitch along the fold.")]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_c('span', {
    staticClass: "ro"
  }, [_c('b', [_vm._v("3.")])]), _vm._v(" Repeat Step 2 to fold, press, and stitch the smaller pocket to make a folded piece 5˝ × 18˝.")]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_c('span', {
    staticClass: "ro"
  }, [_c('b', [_vm._v("4.")])]), _vm._v(" Test your fabric-marking pen on a scrap of your fabric and make sure the marks will come off easily. Use a ruler to mark the large pocket with a vertical line 6˝ in from each end to make 3 even sections.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg6-1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_c('span', {
    staticClass: "ro"
  }, [_c('b', [_vm._v("5.")])]), _vm._v(" On the small pocket, mark a vertical line at the center (9˝) and a line 4½˝ on either side of the center to divide the pocket into 4 equal parts.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg6-2.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_c('b', [_vm._v("SEW THE DIVIDED POCKETS")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentsa"
  }, [_c('span', {
    staticClass: "ro"
  }, [_c('b', [_vm._v("1.")])]), _vm._v(" Layer the small pocket on top of the large pocket, aligning the raw edges at the bottom. Sew through both pockets on the marked center line of the small pocket.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg6-3.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_c('span', {
    staticClass: "ro"
  }, [_c('b', [_vm._v("2.")])]), _vm._v(" Layer the pocket unit on top of the front apron body piece, aligning the raw edges at the bottom. Fold (and pin if needed) the small pocket over to the center to expose the 6˝ line on the large pocket underneath. Sew on the 6˝ line through only the large pocket and the apron body.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg7.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_c('span', {
    staticClass: "ro"
  }, [_c('b', [_vm._v("3.")])]), _vm._v(" Unfold the small pocket to cover up the line you just sewed. Fold the apron body under toward the center. Sew through just the small and large pockets on the 4½˝ line on the small pocket.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg7-1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_c('span', {
    staticClass: "ro"
  }, [_c('b', [_vm._v("4.")])]), _vm._v(" Repeat Steps 2 and 3 to sew the pockets on the other side of the apron. All this switching up of layers will give you 7 useful and different-sized pockets.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg7-2.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_c('b', [_vm._v("MAKE THE TIES")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentsa"
  }, [_c('span', {
    staticClass: "ro"
  }, [_c('b', [_vm._v("1.")])]), _vm._v(" Fold and press the tie strips in half lengthwise, wrong sides together, and then fold and press the raw edges in toward the center fold. Edgestitch both ties closed along the open edges.")]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_c('span', {
    staticClass: "ro"
  }, [_c('b', [_vm._v("2.")])]), _vm._v(" Pin the ties to the sides of the front apron body ¾˝ down from the top edge. Baste in place. Knot the loose ends of the ties together in the center of the apron body and pin them down so they won’t work their way back to the edge of the apron body for the next step.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg7-3.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_c('b', [_vm._v("FINISH THE APRON")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentsa"
  }, [_c('span', {
    staticClass: "ro"
  }, [_c('b', [_vm._v("1.")])]), _vm._v(" Pin both apron bodies right sides together, starting at the corners. Sew them together with a ½˝ seam allowance, leaving a 4˝–5˝ opening on the top edge.")]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_c('span', {
    staticClass: "ro"
  }, [_c('b', [_vm._v("2.")])]), _vm._v(" Trim the seams down to ¼˝ and clip the corners. Pull the apron right side out through the opening. Poke out the corners with a chopstick, and iron the apron nice and flat. Fold the opening edges in and iron them flat so they match the seam.")]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_c('span', {
    staticClass: "ro"
  }, [_c('b', [_vm._v("3.")])]), _vm._v(" I like to use a strip of fusible web to close up the opening. This will ensure that the opening looks nice and neat and is practically unnoticeable. Measure the opening and cut a piece of fusible web to fit. Fuse in place according to directions on the package.")]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_vm._v("If you prefer, blindstitch the opening closed.")]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_c('span', {
    staticClass: "ro"
  }, [_c('b', [_vm._v("4.")])]), _vm._v(" Finally, edgestitch all the way around the apron to finish it up.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cbff5012","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter2.vue
// module id = 66
// module chunks = 0